var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-dropdown',{attrs:{"items":_vm.items}}),_c('ehr-context-activity-dialog',{ref:"activityDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }